if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.cartNoti = document.querySelector("cart-notification");
        this.cartDrawer = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        setTimeout(() => {
          this.submitButton.classList.remove("not-active");
        },100);
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.submitQuickadd();
      }

      submitQuickadd() {
        const submitBtnCs = this.querySelector('.product-form__submit-not-select');
        const variantOptions = this.querySelectorAll('fieldset.product-form__input input');
        const groupBtn = this.closest('.group-button');
        const errorMessageQuickAdd = groupBtn.querySelector('.message-error-quick-add');
        submitBtnCs.addEventListener('click', () => {
          if (variantOptions.length < 1) {
            errorMessageQuickAdd?.classList.remove('hidden');
            setTimeout(() => {
              errorMessageQuickAdd?.classList.add('hidden');
            }, 5000);
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        /*         console.log("Drawer Event Started"); */
        /*         console.log(this.submitButton); */
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        /*     this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        ); */

        const configNoti = fetchConfig("javascript");
        configNoti.headers["X-Requested-With"] = "XMLHttpRequest";
        delete configNoti.headers["Content-Type"];

        const configDrawer = fetchConfig("javascript");
        configDrawer.headers["X-Requested-With"] = "XMLHttpRequest";
        delete configDrawer.headers["Content-Type"];

        const formDataNoti = new FormData(this.form);
        const formDataDrawer = new FormData(this.form);
        let quantity = parseInt(this.submitButton.getAttribute("data-quantity"));
        if (this.submitButton.closest(".group-button")) {
          if (this.submitButton.closest(".group-button").querySelector(".quantity__input")) {
            const quantity_input = this.submitButton.closest(".group-button").querySelector(".quantity__input");
            quantity = parseInt(quantity_input.value);
          }
        }
        if (quantity > 0) {
          formDataNoti.append("quantity", quantity);
          formDataDrawer.append("quantity", quantity);
        }
        if (this.cartNoti) {
          formDataNoti.append(
            "sections",
            this.cartNoti.getSectionsToRenderNoti().map((section) => section.id)
          );
          formDataNoti.append("sections_url", window.location.pathname);
          this.cartNoti.setActiveElementCartNoti(document.activeElement);
        }
        if (this.cartDrawer) {
          formDataDrawer.append(
            "sections",
            this.cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formDataDrawer.append("sections_url", window.location.pathname);
          this.cartDrawer.setActiveElement(document.activeElement);
        }
        configNoti.body = formDataNoti;
        configDrawer.body = formDataDrawer;

        fetch(`${routes.cart_add_url}`, configNoti)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formDataNoti.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formDataNoti.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cartNoti.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cartNoti.renderContents(response);
              this.cartDrawer.renderContents(response);
            }

            // Coloca el código aquí para desactivar el botón en el cart-drawer si es necesario
            var trueFound = false;
            var falseFound = false;

            if (trueFound && falseFound) {
              var button = document.getElementById("CartDrawer-Checkout");
              button.setAttribute("disabled", "disabled");
              var popup = document.getElementById("drawer-popup");
              popup.style.display = "block";
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cartNoti && this.cartNoti.classList.contains("is-empty"))
              this.cartNoti.classList.remove("is-empty");
            if (this.cartDrawer && this.cartDrawer.classList.contains("is-empty"))
              this.cartDrawer.classList.remove("is-empty");

            // Call the function to get the most expensive product's id
            let mostExpensiveId = getMostExpensiveProductId();

            /*if (typeof mostExpensiveId == "string") {
              getProductRelated("gid://shopify/Product/" + mostExpensiveId);
            }*/

            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });

      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
